const postalObject = (data, customerId) => {
	return {
		serviceId: data.service.serviceId,
		emailTemplate: data.service.emailTemplate,
		serviceName: data.service.serviceName,
		serviceType: data.service.serviceType,
		labCode: data.service.tdlLabCode || null,
		price: data.service.price ? data.service.price / 100 : null,
		referrer: data.referrer || null,
		postal: {
			postageAddressLine1: data.postal.postageAddressLine1,
			postageAddressLine2: data.postal.postageAddressLine2,
			postageCity: data.postal.postageCity,
			postagePostcode: data.postal.postagePostcode,
			postageCountry: data.postal.postageCountry,
		},
		bookingEntity: {
			entityId: data.entity ? data.entity.entityId : null,
			entityName: data.entity ? data.entity.entityName : null,
		},
		customers: [
			{
				customerId: customerId,
				firstName: data.customer.firstName,
				lastName: data.customer.lastName,
				name: data.customer.firstName + ' ' + data.customer.lastName,
				emailAddress: data.customer.emailAddress,
				gender: data.customer.gender,
				dateOfBirth: data.customer.dateOfBirth,
				phone: data.customer.phoneNumber || '',
				customerNotes: data.appointmentNotes || '',
			},
		],
		accountTo: data.accountTo || 'Sirkka Health',
		bookingSource: data.source || 'SIRKKA_User_Individual_Booking',
		company: data.entity.entityName || null,
	};
};

export default postalObject;
